function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * In-game crypto receive overlay — waiting for / confirming inbound payment.
 *
 * Presentation: `mods/crypto/web/css/crypto-overlays.css` (`.crypto-receive-overlay`).
 *
 * Preference: crypto_transfers_inbound_trusted (UI/storage; auto-skip behavior later).
 *
 * Queue resume is one-shot via completeReceiveOnce():
 *   - Continue click → completeReceiveOnce()
 *   - Payment arrived → success UI, then completeReceiveOnce()
 * Overlay close must not re-fire the game callback.
 */

var GameReceiveTemplate = require('./game-receive.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
var GameReceive = /*#__PURE__*/function () {
  function GameReceive(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, GameReceive);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.overlay.clickBackdropToClose = false;

    /** @type {ReturnType<GameReceive['bindElements']> | null} */
    this.el = null;
    this.expected_hash = null;
    this.mycallback = null;
    this.receive_completed = false;
    this.app.connection.on('saito-crypto-game-receive-render-request', function (details) {
      _this.render(details);
    });
    this.app.connection.on('on-receive-expected-payment', function (hash, details) {
      if (hash == _this.expected_hash) {
        _this.onReceivePayment();
      }
    });
  }

  /**
   * First-time / absent preference → checked (opt-in invitation).
   * After the user has saved a value → reflect that stored preference.
   */
  return _createClass(GameReceive, [{
    key: "readInboundCheckboxDefault",
    value: function readInboundCheckboxDefault() {
      var _this$app$options;
      var pref = (_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.gameprefs) === null || _this$app$options === void 0 ? void 0 : _this$app$options.crypto_transfers_inbound_trusted;
      if (pref === undefined || pref === null) {
        return true;
      }
      return !!pref;
    }

    /**
     * @returns {null | {
     *   root: HTMLElement,
     *   title: HTMLElement | null,
     *   amount: HTMLElement | null,
     *   countdown: HTMLElement | null,
     *   closeBtn: HTMLButtonElement | null,
     *   ignoreCheckbox: HTMLInputElement | null
     * }}
     */
  }, {
    key: "bindElements",
    value: function bindElements() {
      var root = document.getElementById('receive-crypto-request-root');
      if (root) {
        return {
          root: root,
          title: root.querySelector('#crypto_receive_title'),
          amount: root.querySelector('#crypto_receive_amount'),
          countdown: root.querySelector('#crypto_receive_countdown'),
          closeBtn: root.querySelector('#crypto_receive_continue'),
          ignoreCheckbox: root.querySelector('#crypto_receive_auto_accept')
        };
      } else {
        return null;
      }
    }
  }, {
    key: "saveInboundPreferenceFromCheckbox",
    value: function saveInboundPreferenceFromCheckbox() {
      var checkbox = document.getElementById('crypto_receive_auto_accept');
      this.app.options.gameprefs = this.app.options.gameprefs || {};
      this.app.options.gameprefs.crypto_transfers_inbound_trusted = checkbox !== null && checkbox !== void 0 && checkbox.checked ? 1 : 0;
      this.app.storage.saveOptions();
    }

    /**
     * One-shot: resume the game queue and close the overlay.
     * Safe to call from Continue or from payment-arrived auto-continue.
     */
  }, {
    key: "completeReceiveOnce",
    value: function completeReceiveOnce() {
      if (this.receive_completed) {
        return;
      }
      this.receive_completed = true;
      this.expected_hash = null;
      this.saveInboundPreferenceFromCheckbox();
      var cb = this.mycallback;
      this.mycallback = null;
      if (typeof cb === 'function') {
        cb();
      }
      this.overlay.close();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this$el,
        _this2 = this;
      if ((_this$el = this.el) !== null && _this$el !== void 0 && _this$el.closeBtn) {
        this.el.closeBtn.addEventListener('click', function () {
          _this2.completeReceiveOnce();
        });
      }
    }

    /**
     * Shows a confirmation overlay while waiting for an inbound crypto transfer.
     * @param details {{ ticker: string, amount: string, publicKey: string, address: string, mycallback?: function }}
     */
  }, {
    key: "render",
    value: function render(details) {
      var _this3 = this,
        _this$el2;
      if (!(details !== null && details !== void 0 && details.ticker) || !(details !== null && details !== void 0 && details.amount)) {
        console.error('Missing ticker/amount in Receive Crypto Overlay');
        return;
      }
      if (!(details !== null && details !== void 0 && details.publicKey) || !(details !== null && details !== void 0 && details.address)) {
        console.error('Missing address in Receive Crypto Overlay');
        return;
      }
      this.expected_hash = details.hash;
      this.mycallback = typeof details.mycallback === 'function' ? details.mycallback : null;
      this.receive_completed = false;
      var publicKey = details.publicKey;
      details.trustedInbound = this.readInboundCheckboxDefault();
      details.partyName = escapeHtml(this.app.keychain.returnUsername(publicKey));
      details.partyKey = escapeHtml(publicKey);
      this.overlay.show(GameReceiveTemplate(details), function () {
        _this3.expected_hash = null;
        // Queue resume is owned by completeReceiveOnce(); close must not re-fire it.
        _this3.mycallback = null;
      });
      this.overlay.blockClose();
      this.el = this.bindElements();
      if (!((_this$el2 = this.el) !== null && _this$el2 !== void 0 && _this$el2.root)) {
        console.error('Error rendering receive overlay');
        return;
      }
      this.attachEvents();
    }
  }, {
    key: "onReceivePayment",
    value: function onReceivePayment() {
      this.expected_hash = null;
      var root = this.bindElements();
      if (root !== null && root !== void 0 && root.title) {
        root.title.textContent = 'Payment Received';
      }
      if (root !== null && root !== void 0 && root.root) {
        root.root.dataset.receiveState = 'success';
      }

      // Auto-Continue: same one-shot path as the Continue button.
      this.completeReceiveOnce();
    }
  }]);
}();
module.exports = GameReceive;